(function () {
  'use strict';
  /**
   * @param {HTMLElement} [root] - [optional] element where the cookieconsent will be appended
   * @returns {Object} cookieconsent object with API
   */
  var CookieConsent = function (root) {

    /**
     * CHANGE THIS FLAG FALSE TO DISABLE console.log()
     */
    var ENABLE_LOGS = true;

    var _config = {
      'mode': 'opt-in',                         // 'opt-in', 'opt-out'
      'current_lang': 'en',
      'auto_language': null,
      'autorun': true,                          // run as soon as loaded
      'page_scripts': true,
      'hide_from_bots': true,
      'cookie_name': 'gruf_cookie',
      'cookie_expiration': 182,                 // default: 6 months (in days)
      'cookie_domain': window.location.hostname, // default: current domain
      'cookie_path': '/',
      'cookie_same_site': 'Lax',
      'use_rfc_cookie': false,
      'autoclear_cookies': true,
      'revision': 0,
      'script_selector': 'data-cookiecategory'
    };

    /**
     * Object which holds the main methods/API (.show, .run, .destroy, ...)
     */
    var _cookieconsent = {};

    /**
     * Global user configuration object & Internal state variables
     */
    var user_config;
    var saved_cookie_content = {};
    var cookie_data = null;
    var consent_date;
    var last_consent_update;
    var consent_uuid;
    var invalid_consent = true;
    var consent_modal_exists = false;
    var consent_modal_visible = false;
    var settings_modal_visible = false;
    var clicked_inside_modal = false;
    var current_modal_focusable;
    var all_table_headers;
    var all_blocks;

    // Helper callback functions
    var onAccept;
    var onChange;
    var onFirstAction;

    var revision_enabled = false;
    var valid_revision = true;
    var revision_message = '';

    // State variables for the autoclearCookies function
    var changed_settings = [];
    var reload_page = false;

    // Accept type & categories
    var accept_type;
    var accepted_categories = [];
    var rejected_categories = [];
    var default_enabled_categories = [];
    var is_bot = false;

    // Focus references
    var last_elem_before_modal;
    var last_consent_modal_btn_focus;
    var consent_modal_focusable = [];
    var settings_modal_focusable = [];

    // Keep track of toggle states and categories
    var toggle_states = [];
    var all_categories = [];
    var readonly_categories = [];

    // Event Listener Trackers for Memory Leak Prevention
    var _focusTrapListener = null;
    var _mainContainerClickListener = null;
    var _keydownEscapeListener = null;

    /**
     * Pointers to main dom elements
     */
    var html_dom = document.documentElement;
    var main_container;
    var all_modals_container;
    var consent_modal;
    var consent_modal_title;
    var consent_modal_description;
    var consent_primary_btn;
    var consent_secondary_btn;
    var consent_buttons;
    var consent_modal_inner;
    var settings_container;
    var settings_inner;
    var settings_title;
    var settings_close_btn;
    var settings_blocks;
    var new_settings_blocks;
    var settings_buttons;
    var settings_save_btn;
    var settings_accept_all_btn;
    var settings_reject_all_btn;

    /**
     * Update config settings
     * @param {Object} _user_config
     */
    var _setConfig = function (_user_config) {
      user_config = _user_config;

      if (typeof user_config['cookie_expiration'] === "number") _config.cookie_expiration = user_config['cookie_expiration'];
      if (typeof user_config['cookie_necessary_only_expiration'] === "number") _config.cookie_necessary_only_expiration = user_config['cookie_necessary_only_expiration'];
      if (typeof user_config['autorun'] === "boolean") _config.autorun = user_config['autorun'];
      if (typeof user_config['cookie_domain'] === "string") _config.cookie_domain = user_config['cookie_domain'];
      if (typeof user_config['cookie_same_site'] === "string") _config.cookie_same_site = user_config['cookie_same_site'];
      if (typeof user_config['cookie_path'] === "string") _config.cookie_path = user_config['cookie_path'];
      if (typeof user_config['cookie_name'] === "string") _config.cookie_name = user_config['cookie_name'];
      if (typeof user_config['onAccept'] === "function") onAccept = user_config['onAccept'];
      if (typeof user_config['onFirstAction'] === "function") onFirstAction = user_config['onFirstAction'];
      if (typeof user_config['onChange'] === "function") onChange = user_config['onChange'];
      if (user_config['mode'] === 'opt-out') _config.mode = 'opt-out';

      if (typeof user_config['revision'] === "number") {
        user_config['revision'] > -1 && (_config.revision = user_config['revision']);
        revision_enabled = true;
      }

      if (typeof user_config['autoclear_cookies'] === "boolean") _config.autoclear_cookies = user_config['autoclear_cookies'];
      if (user_config['use_rfc_cookie'] === true) _config.use_rfc_cookie = true;

      if (typeof user_config['hide_from_bots'] === "boolean") {
        _config.hide_from_bots = user_config['hide_from_bots'];
      }

      if (_config.hide_from_bots) {
        is_bot = navigator && ((navigator.userAgent && /bot|crawl|spider|slurp|teoma/i.test(navigator.userAgent)) || navigator.webdriver);
      }

      _config.page_scripts = user_config['page_scripts'] === true;

      if (user_config['auto_language'] === 'browser' || user_config['auto_language'] === true) {
        _config.auto_language = 'browser';
      } else if (user_config['auto_language'] === 'document') {
        _config.auto_language = 'document';
      }

      _config.current_lang = _resolveCurrentLang(user_config.languages, user_config['current_lang']);
    };

    var _addDataButtonListeners = function (elem) {
      var _a = 'accept-';
      var show_settings = _getElements('c-settings');
      var accept_all = _getElements(_a + 'all');
      var accept_necessary = _getElements(_a + 'necessary');
      var accept_custom_selection = _getElements(_a + 'custom');

      for (var i = 0; i < show_settings.length; i++) {
        show_settings[i].setAttribute('aria-haspopup', 'dialog');
        _addEvent(show_settings[i], 'click', function (event) {
          event.preventDefault();
          _cookieconsent.showSettings(0);
        });
      }

      for (i = 0; i < accept_all.length; i++) {
        _addEvent(accept_all[i], 'click', function (event) {
          _acceptAction(event, 'all');
        });
      }

      for (i = 0; i < accept_custom_selection.length; i++) {
        _addEvent(accept_custom_selection[i], 'click', function (event) {
          _acceptAction(event);
        });
      }

      for (i = 0; i < accept_necessary.length; i++) {
        _addEvent(accept_necessary[i], 'click', function (event) {
          _acceptAction(event, []);
        });
      }

      function _getElements(data_role) {
        return (elem || document).querySelectorAll('a[data-cc="' + data_role + '"], button[data-cc="' + data_role + '"]');
      }

      function _acceptAction(e, accept_type) {
        e.preventDefault();
        _cookieconsent.accept(accept_type);
        _cookieconsent.hideSettings();
        _cookieconsent.hide();
      }
    };

    var _getValidatedLanguage = function (lang, all_languages) {
      if (Object.prototype.hasOwnProperty.call(all_languages, lang)) {
        return lang;
      } else if (_getKeys(all_languages).length > 0) {
        if (Object.prototype.hasOwnProperty.call(all_languages, _config.current_lang)) {
          return _config.current_lang;
        } else {
          return _getKeys(all_languages)[0];
        }
      }
    };

    var _getModalFocusableData = function () {
      var allowed_focusable_types = ['[href]', 'button', 'input', 'details', '[tabindex="0"]'];

      function _getAllFocusableElements(modal, _array) {
        var focus_later = false, focus_first = false;
        try {
          var focusable_elems = modal.querySelectorAll(allowed_focusable_types.join(':not([tabindex="-1"]), '));
          var attr, len = focusable_elems.length, i = 0;

          while (i < len) {
            attr = focusable_elems[i].getAttribute('data-focus');
            if (!focus_first && attr === "1") {
              focus_first = focusable_elems[i];
            } else if (attr === "0") {
              focus_later = focusable_elems[i];
              if (!focus_first && focusable_elems[i + 1].getAttribute('data-focus') !== "0") {
                focus_first = focusable_elems[i + 1];
              }
            }
            i++;
          }
        } catch (e) {
          return modal.querySelectorAll(allowed_focusable_types.join(', '));
        }

        _array[0] = focusable_elems[0];
        _array[1] = focusable_elems[focusable_elems.length - 1];
        _array[2] = focus_later;
        _array[3] = focus_first;
      }

      _getAllFocusableElements(settings_inner, settings_modal_focusable);
      if (consent_modal_exists) {
        _getAllFocusableElements(consent_modal, consent_modal_focusable);
      }
    };

    var _createConsentModal = function (lang) {
      if (user_config['force_consent'] === true) _addClass(html_dom, 'force--consent');

      if (!consent_modal) {
        consent_modal = _createNode('div');
        var consent_modal_inner_inner = _createNode('div');
        var overlay = _createNode('div');

        consent_modal.id = 'cm';
        consent_modal_inner_inner.id = 'c-inr-i';
        consent_modal_inner_inner.class = 'c-flex';
        overlay.id = 'cm-ov';

        consent_modal.setAttribute('role', 'dialog');
        consent_modal.setAttribute('aria-modal', 'true');
        consent_modal.setAttribute('aria-hidden', 'false');
        consent_modal.setAttribute('aria-labelledby', 'c-ttl');
        consent_modal.setAttribute('aria-describedby', 'c-txt');

        all_modals_container.appendChild(consent_modal);
        all_modals_container.appendChild(overlay);

        consent_modal.style.visibility = overlay.style.visibility = "hidden";
        overlay.style.opacity = 0;
      }

      var consent_modal_title_value = user_config.languages[lang]['consent_modal']['title'];

      if (consent_modal_title_value) {
        if (!consent_modal_title) {
          consent_modal_title = _createNode('div');
          consent_modal_title.id = 'c-ttl';
          consent_modal_title.setAttribute('role', 'heading');
          consent_modal_title.setAttribute('aria-level', '2');
          consent_modal_inner_inner.appendChild(consent_modal_title);
        }
        consent_modal_title.innerHTML = consent_modal_title_value;
      }

      var description = user_config.languages[lang]['consent_modal']['description'];

      if (revision_enabled) {
        if (!valid_revision) {
          description = description.replace("{{revision_message}}", revision_message || user_config.languages[lang]['consent_modal']['revision_message'] || "");
        } else {
          description = description.replace("{{revision_message}}", "");
        }
      }

      if (!consent_modal_description) {
        consent_modal_description = _createNode('div');
        consent_modal_description.id = 'c-txt';
        consent_modal_inner_inner.appendChild(consent_modal_description);
      }

      consent_modal_description.innerHTML = description;

      var primary_btn_data = user_config.languages[lang]['consent_modal']['primary_btn'];
      var secondary_btn_data = user_config.languages[lang]['consent_modal']['secondary_btn'];

      if (primary_btn_data) {
        if (!consent_primary_btn) {
          consent_primary_btn = _createNode('button');
          consent_primary_btn.id = 'c-p-bn';
          consent_primary_btn.className = "c-bn";

          var _accept_type;
          if (primary_btn_data['role'] === 'accept_all') _accept_type = 'all';

          _addEvent(consent_primary_btn, "click", function () {
            _cookieconsent.hide();
            _cookieconsent.accept(_accept_type);
          });
        }
        consent_primary_btn.innerHTML = user_config.languages[lang]['consent_modal']['primary_btn']['text'];
      }

      if (secondary_btn_data) {
        if (!consent_secondary_btn) {
          consent_secondary_btn = _createNode('button');
          consent_secondary_btn.id = 'c-s-bn';
          consent_secondary_btn.className = "c-bn c_link";

          if (secondary_btn_data['role'] === 'accept_necessary') {
            _addEvent(consent_secondary_btn, 'click', function () {
              _cookieconsent.hide();
              _cookieconsent.accept([]); 
            });
          } else {
            _addEvent(consent_secondary_btn, 'click', function () {
              _cookieconsent.showSettings(0);
            });
          }
        }
        consent_secondary_btn.innerHTML = user_config.languages[lang]['consent_modal']['secondary_btn']['text'];
      }

      var gui_options_data = user_config['gui_options'];

      if (!consent_modal_inner) {
        consent_modal_inner = _createNode('div');
        consent_modal_inner.id = 'c-inr';
        consent_modal_inner.appendChild(consent_modal_inner_inner);
      }

      if (!consent_buttons) {
        consent_buttons = _createNode('div');
        consent_buttons.id = "c-bns";

        if (gui_options_data && gui_options_data['consent_modal'] && gui_options_data['consent_modal']['swap_buttons'] === true) {
          secondary_btn_data && consent_buttons.appendChild(consent_secondary_btn);
          primary_btn_data && consent_buttons.appendChild(consent_primary_btn);
          consent_buttons.className = 'swap';
        } else {
          primary_btn_data && consent_buttons.appendChild(consent_primary_btn);
          secondary_btn_data && consent_buttons.appendChild(consent_secondary_btn);
        }

        (primary_btn_data || secondary_btn_data) && consent_modal_inner.appendChild(consent_buttons);
        consent_modal.appendChild(consent_modal_inner);
      }

      consent_modal_exists = true;
      _addDataButtonListeners(consent_modal_inner);
    };

    var _createSettingsModal = function (lang) {
      if (!settings_container) {
        settings_container = _createNode('div');
        var settings_container_valign = _createNode('div');
        var settings = _createNode('div');
        var settings_container_inner = _createNode('div');
        settings_inner = _createNode('div');
        settings_title = _createNode('div');
        var settings_header = _createNode('div');
        settings_close_btn = _createNode('button');
        var settings_close_btn_container = _createNode('div');
        settings_blocks = _createNode('div');
        var overlay = _createNode('div');

        settings_container.id = 's-cnt';
        settings_container_valign.id = "c-vln";
        settings_container_inner.id = "c-s-in";
        settings.id = "cs";
        settings_title.id = 's-ttl';
        settings_inner.id = 's-inr';
        settings_header.id = "s-hdr";
        settings_blocks.id = 's-bl';
        settings_close_btn.id = 's-c-bn';
        overlay.id = 'cs-ov';
        settings_close_btn_container.id = 's-c-bnc';
        settings_close_btn.className = 'c-bn';

        settings_container.setAttribute('role', 'dialog');
        settings_container.setAttribute('aria-modal', 'true');
        settings_container.setAttribute('aria-hidden', 'true');
        settings_container.setAttribute('aria-labelledby', 's-ttl');
        settings_title.setAttribute('role', 'heading');
        settings_container.style.visibility = overlay.style.visibility = "hidden";
        overlay.style.opacity = 0;

        settings_close_btn_container.appendChild(settings_close_btn);

        // Store event listener reference to allow safe destruction
        _keydownEscapeListener = function (evt) {
          evt = evt || window.event;
          if (evt.keyCode === 27) {
            _cookieconsent.hideSettings(0);
          }
        };
        _addEvent(settings_container_valign, 'keydown', _keydownEscapeListener, true);

        _addEvent(settings_close_btn, 'click', function () {
          _cookieconsent.hideSettings(0);
        });
      } else {
        new_settings_blocks = _createNode('div');
        new_settings_blocks.id = 's-bl';
      }

      settings_close_btn.setAttribute('aria-label', user_config.languages[lang]['settings_modal']['close_btn_label'] || 'Close');

      all_blocks = user_config.languages[lang]['settings_modal']['blocks'];
      all_table_headers = user_config.languages[lang]['settings_modal']['cookie_table_headers'];

      var n_blocks = all_blocks.length;
      settings_title.innerHTML = user_config.languages[lang]['settings_modal']['title'];

      for (var i = 0; i < n_blocks; ++i) {
        var title_data = all_blocks[i]['title'],
          description_data = all_blocks[i]['description'],
          toggle_data = all_blocks[i]['toggle'],
          cookie_table_data = all_blocks[i]['cookie_table'],
          remove_cookie_tables = user_config['remove_cookie_tables'] === true,
          isExpandable = (description_data && 'truthy') || (!remove_cookie_tables && (cookie_table_data && 'truthy'));

        var block_section = _createNode('div');
        var block_table_container = _createNode('div');

        if (description_data) {
          var block_desc = _createNode('div');
          block_desc.className = 'p';
          block_desc.insertAdjacentHTML('beforeend', description_data);
        }

        var block_title_container = _createNode('div');
        block_title_container.className = 'title';

        block_section.className = 'c-bl';
        block_table_container.className = 'desc';

        if (typeof toggle_data !== 'undefined') {
          var accordion_id = "c-ac-" + i;

          var block_title_btn = isExpandable ? _createNode('button') : _createNode('div');
          var block_switch_label = _createNode('label');
          var block_switch = _createNode('input');
          var block_switch_span = _createNode('span');
          var label_text_span = _createNode('span');
          var block_switch_span_on_icon = _createNode('span');
          var block_switch_span_off_icon = _createNode('span');

          block_title_btn.className = isExpandable ? 'b-tl exp' : 'b-tl';
          block_switch_label.className = 'b-tg';
          block_switch.className = 'c-tgl';
          block_switch_span_on_icon.className = 'on-i';
          block_switch_span_off_icon.className = 'off-i';
          block_switch_span.className = 'c-tg';
          label_text_span.className = "t-lb";

          if (isExpandable) {
            block_title_btn.setAttribute('aria-expanded', 'false');
            block_title_btn.setAttribute('aria-controls', accordion_id);
          }

          block_switch.type = 'checkbox';
          block_switch_span.setAttribute('aria-hidden', 'true');

          var cookie_category = toggle_data.value;
          block_switch.value = cookie_category;

          label_text_span.textContent = title_data;
          block_title_btn.insertAdjacentHTML('beforeend', title_data);

          block_title_container.appendChild(block_title_btn);
          block_switch_span.appendChild(block_switch_span_on_icon);
          block_switch_span.appendChild(block_switch_span_off_icon);

          if (!invalid_consent) {
            if (_inArray(saved_cookie_content['categories'], cookie_category) > -1) {
              block_switch.checked = true;
              !new_settings_blocks && toggle_states.push(true);
            } else {
              !new_settings_blocks && toggle_states.push(false);
            }
          } else if (toggle_data['enabled']) {
            block_switch.checked = true;
            !new_settings_blocks && toggle_states.push(true);
            if (toggle_data['enabled']) !new_settings_blocks && default_enabled_categories.push(cookie_category);
          } else {
            !new_settings_blocks && toggle_states.push(false);
          }

          !new_settings_blocks && all_categories.push(cookie_category);

          if (toggle_data['readonly']) {
            block_switch.disabled = true;
            _addClass(block_switch_span, 'c-ro');
            !new_settings_blocks && readonly_categories.push(true);
          } else {
            !new_settings_blocks && readonly_categories.push(false);
          }

          _addClass(block_table_container, 'b-acc');
          _addClass(block_title_container, 'b-bn');
          _addClass(block_section, 'b-ex');

          block_table_container.id = accordion_id;
          block_table_container.setAttribute('aria-hidden', 'true');

          block_switch_label.appendChild(block_switch);
          block_switch_label.appendChild(block_switch_span);
          block_switch_label.appendChild(label_text_span);
          block_title_container.appendChild(block_switch_label);

          isExpandable && (function (accordion, block_section, btn) {
            _addEvent(block_title_btn, 'click', function () {
              if (!_hasClass(block_section, 'act')) {
                _addClass(block_section, 'act');
                btn.setAttribute('aria-expanded', 'true');
                accordion.setAttribute('aria-hidden', 'false');
              } else {
                _removeClass(block_section, 'act');
                btn.setAttribute('aria-expanded', 'false');
                accordion.setAttribute('aria-hidden', 'true');
              }
            }, false);
          })(block_table_container, block_section, block_title_btn);

        } else {
          if (title_data) {
            var block_title = _createNode('div');
            block_title.className = 'b-tl';
            block_title.setAttribute('role', 'heading');
            block_title.setAttribute('aria-level', '3');
            block_title.insertAdjacentHTML('beforeend', title_data);
            block_title_container.appendChild(block_title);
          }
        }

        title_data && block_section.appendChild(block_title_container);
        description_data && block_table_container.appendChild(block_desc);

        if (!remove_cookie_tables && typeof cookie_table_data !== 'undefined') {
          var tr_tmp_fragment = document.createDocumentFragment();

          for (var p = 0; p < all_table_headers.length; ++p) {
            var th1 = _createNode('th');
            var obj = all_table_headers[p];
            th1.setAttribute('scope', 'col');
            if (obj) {
              var new_column_key = obj && _getKeys(obj)[0];
              th1.textContent = all_table_headers[p][new_column_key];
              tr_tmp_fragment.appendChild(th1);
            }
          }

          var tr_tmp = _createNode('tr');
          tr_tmp.appendChild(tr_tmp_fragment);

          var thead = _createNode('thead');
          thead.appendChild(tr_tmp);

          var block_table = _createNode('table');
          block_table.appendChild(thead);

          var tbody_fragment = document.createDocumentFragment();

          for (var n = 0; n < cookie_table_data.length; n++) {
            var tr = _createNode('tr');
            for (var g = 0; g < all_table_headers.length; ++g) {
              obj = all_table_headers[g];
              if (obj) {
                new_column_key = _getKeys(obj)[0];
                var td_tmp = _createNode('td');
                td_tmp.insertAdjacentHTML('beforeend', cookie_table_data[n][new_column_key]);
                td_tmp.setAttribute('data-column', obj[new_column_key]);
                tr.appendChild(td_tmp);
              }
            }
            tbody_fragment.appendChild(tr);
          }

          var tbody = _createNode('tbody');
          tbody.appendChild(tbody_fragment);
          block_table.appendChild(tbody);
          block_table_container.appendChild(block_table);
        }

        if (toggle_data && title_data || (!toggle_data && (title_data || description_data))) {
          block_section.appendChild(block_table_container);
          if (new_settings_blocks) new_settings_blocks.appendChild(block_section);
          else settings_blocks.appendChild(block_section);
        }
      }

      if (!settings_buttons) {
        settings_buttons = _createNode('div');
        settings_buttons.id = 's-bns';
      }

      if (!settings_accept_all_btn) {
        settings_accept_all_btn = _createNode('button');
        settings_accept_all_btn.id = 's-all-bn';
        settings_accept_all_btn.className = 'c-bn';
        settings_buttons.appendChild(settings_accept_all_btn);

        _addEvent(settings_accept_all_btn, 'click', function () {
          _cookieconsent.hideSettings();
          _cookieconsent.hide();
          _cookieconsent.accept('all');
        });
      }

      settings_accept_all_btn.innerHTML = user_config.languages[lang]['settings_modal']['accept_all_btn'];

      var reject_all_btn_text = user_config.languages[lang]['settings_modal']['reject_all_btn'];

      if (reject_all_btn_text) {
        if (!settings_reject_all_btn) {
          settings_reject_all_btn = _createNode('button');
          settings_reject_all_btn.id = 's-rall-bn';
          settings_reject_all_btn.className = 'c-bn';

          _addEvent(settings_reject_all_btn, 'click', function () {
            _cookieconsent.hideSettings();
            _cookieconsent.hide();
            _cookieconsent.accept([]);
          });

          settings_inner.className = "bns-t";
          settings_buttons.appendChild(settings_reject_all_btn);
        }
        settings_reject_all_btn.innerHTML = reject_all_btn_text;
      }

      if (!settings_save_btn) {
        settings_save_btn = _createNode('button');
        settings_save_btn.id = 's-sv-bn';
        settings_save_btn.className = 'c-bn';
        settings_buttons.appendChild(settings_save_btn);

        _addEvent(settings_save_btn, 'click', function () {
          _cookieconsent.hideSettings();
          _cookieconsent.hide();
          _cookieconsent.accept();
        });
      }

      settings_save_btn.innerHTML = user_config.languages[lang]['settings_modal']['save_settings_btn'];

      if (new_settings_blocks) {
        settings_inner.replaceChild(new_settings_blocks, settings_blocks);
        settings_blocks = new_settings_blocks;
        return;
      };

      settings_header.appendChild(settings_title);
      settings_header.appendChild(settings_close_btn_container);
      settings_inner.appendChild(settings_header);
      settings_inner.appendChild(settings_blocks);
      settings_inner.appendChild(settings_buttons);
      settings_container_inner.appendChild(settings_inner);

      settings.appendChild(settings_container_inner);
      settings_container_valign.appendChild(settings);
      settings_container.appendChild(settings_container_valign);

      all_modals_container.appendChild(settings_container);
      all_modals_container.appendChild(overlay);
    };

    var _createCookieConsentHTML = function () {
      main_container = _createNode('div');
      main_container.id = 'cc--main';
      main_container.style.position = "fixed";
      main_container.style.zIndex = "2147483647";
      main_container.innerHTML = '<div id="cc_div" class="cc_div"></div>';
      all_modals_container = main_container.children[0];

      var lang = _config.current_lang;

      if (consent_modal_exists) _createConsentModal(lang);
      _createSettingsModal(lang);

      (root || document.body).appendChild(main_container);
    };

    _cookieconsent.updateLanguage = function (lang, force) {
      if (typeof lang !== 'string') return;
      var new_validated_lang = _getValidatedLanguage(lang, user_config.languages);

      if (new_validated_lang !== _config.current_lang || force === true) {
        _config.current_lang = new_validated_lang;
        if (consent_modal_exists) {
          _createConsentModal(new_validated_lang);
        }
        _createSettingsModal(new_validated_lang);
        return true;
      }
      return false;
    };

    var _autoclearCookies = function (clearOnFirstAction) {
      var len = all_blocks.length;
      var count = -1;
      reload_page = false;

      var all_cookies_array = _getCookie('', 'all');
      var domains = [_config.cookie_domain, '.' + _config.cookie_domain];

      if (_config.cookie_domain.slice(0, 4) === 'www.') {
        var non_www_domain = _config.cookie_domain.substr(4);
        domains.push(non_www_domain);
        domains.push('.' + non_www_domain);
      }

      for (var i = 0; i < len; i++) {
        var curr_block = all_blocks[i];

        if (Object.prototype.hasOwnProperty.call(curr_block, "toggle")) {
          var category_just_disabled = _inArray(changed_settings, curr_block['toggle']['value']) > -1;
          
          if (!toggle_states[++count] && Object.prototype.hasOwnProperty.call(curr_block, "cookie_table") && (clearOnFirstAction || category_just_disabled)) {
            var curr_cookie_table = curr_block['cookie_table'];
            var ckey = _getKeys(all_table_headers[0])[0];
            var clen = curr_cookie_table.length;

            if (curr_block['toggle']['reload'] === 'on_disable') category_just_disabled && (reload_page = true);

            for (var j = 0; j < clen; j++) {
              var curr_domains = domains;
              var curr_row = curr_cookie_table[j], found_cookies = [];
              var curr_cookie_name = curr_row[ckey];
              var is_regex = curr_row['is_regex'] || false;
              var curr_cookie_domain = curr_row['domain'] || null;
              var curr_cookie_path = curr_row['path'] || false;

              curr_cookie_domain && (curr_domains = [curr_cookie_domain, '.' + curr_cookie_domain]);

              if (is_regex) {
                for (var n = 0; n < all_cookies_array.length; n++) {
                  if (all_cookies_array[n].match(curr_cookie_name)) {
                    found_cookies.push(all_cookies_array[n]);
                  }
                }
              } else {
                var found_index = _inArray(all_cookies_array, curr_cookie_name);
                if (found_index > -1) found_cookies.push(all_cookies_array[found_index]);
              }

              if (found_cookies.length > 0) {
                _eraseCookies(found_cookies, curr_cookie_path, curr_domains);
                curr_block['toggle']['reload'] === 'on_clear' && (reload_page = true);
              }
            }
          }
        }
      }
    };

    var _saveCookiePreferences = function (accepted_categories) {
      changed_settings = [];
      var category_toggles = document.querySelectorAll('.c-tgl') || [];

      if (category_toggles.length > 0) {
        for (var i = 0; i < category_toggles.length; i++) {
          if (_inArray(accepted_categories, all_categories[i]) !== -1) {
            category_toggles[i].checked = true;
            if (!toggle_states[i]) {
              changed_settings.push(all_categories[i]);
              toggle_states[i] = true;
            }
          } else {
            category_toggles[i].checked = false;
            if (toggle_states[i]) {
              changed_settings.push(all_categories[i]);
              toggle_states[i] = false;
            }
          }
        }
      }

      if (!invalid_consent && _config.autoclear_cookies && changed_settings.length > 0)
        _autoclearCookies();

      if (!consent_date) consent_date = new Date();
      if (!consent_uuid) consent_uuid = _uuidv4();

      saved_cookie_content = {
        "categories": accepted_categories,
        "level": accepted_categories,
        "revision": _config.revision,
        "data": cookie_data,
        "rfc_cookie": _config.use_rfc_cookie,
        "consent_date": consent_date.toISOString(),
        "consent_uuid": consent_uuid
      };

      if (invalid_consent || changed_settings.length > 0) {
        valid_revision = true;
        if (!last_consent_update) last_consent_update = consent_date;
        else last_consent_update = new Date();

        saved_cookie_content['last_consent_update'] = last_consent_update.toISOString();
        accept_type = _getAcceptType(_getCurrentCategoriesState());
        
        _setCookie(_config.cookie_name, JSON.stringify(saved_cookie_content));
        _manageExistingScripts();
      }

      if (invalid_consent) {
        if (_config.autoclear_cookies) _autoclearCookies(true);
        if (typeof onFirstAction === 'function') onFirstAction(_cookieconsent.getUserPreferences(), saved_cookie_content);
        if (typeof onAccept === 'function') onAccept(saved_cookie_content);

        invalid_consent = false;
        if (_config.mode === 'opt-in') return;
      }

      if (typeof onChange === "function" && changed_settings.length > 0)
        onChange(saved_cookie_content, changed_settings);

      if (reload_page) window.location.reload();
    };

    var _inArray = function (arr, value) {
      return arr.indexOf(value);
    };

    var _log = function (print_msg, optional_param, error) {
      ENABLE_LOGS && (!error ? console.log(print_msg, optional_param !== undefined ? optional_param : ' ') : console.error(print_msg, optional_param || ""));
    };

    var _createNode = function (type) {
      var el = document.createElement(type);
      if (type === 'button') {
        el.setAttribute('type', type);
      }
      return el;
    };

    var _uuidv4 = function () {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        try {
          return (c ^ (window.crypto || window.msCrypto).getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        } catch (e) {
          return '';
        }
      });
    };

    var _resolveCurrentLang = function (languages, requested_language) {
      if (_config.auto_language === 'browser') {
        return _getValidatedLanguage(_getBrowserLang(), languages);
      } else if (_config.auto_language === 'document') {
        return _getValidatedLanguage(document.documentElement.lang, languages);
      } else {
        if (typeof requested_language === 'string') {
          return _config.current_lang = _getValidatedLanguage(requested_language, languages);
        }
      }
      return _config.current_lang;
    };

    var _getBrowserLang = function () {
      var browser_lang = navigator.language || navigator.browserLanguage;
      browser_lang.length > 2 && (browser_lang = browser_lang[0] + browser_lang[1]);
      return browser_lang.toLowerCase();
    };

    var _handleFocusTrap = function () {
      var tabbedOutsideDiv = false;
      var tabbedInsideModal = false;

      // Ensure cleanup of previous listeners if initialized multiple times
      if (_focusTrapListener) {
        document.removeEventListener('keydown', _focusTrapListener);
      }

      _focusTrapListener = function (e) {
        e = e || window.event;
        if (e.key !== 'Tab') return;

        if (current_modal_focusable) {
          if (e.shiftKey) {
            if (document.activeElement === current_modal_focusable[0]) {
              current_modal_focusable[1].focus();
              e.preventDefault();
            }
          } else {
            if (document.activeElement === current_modal_focusable[1]) {
              current_modal_focusable[0].focus();
              e.preventDefault();
            }
          }

          if (!tabbedInsideModal && !clicked_inside_modal) {
            tabbedInsideModal = true;
            !tabbedOutsideDiv && e.preventDefault();

            if (e.shiftKey) {
              if (current_modal_focusable[3]) {
                if (!current_modal_focusable[2]) current_modal_focusable[0].focus();
                else current_modal_focusable[2].focus();
              } else {
                current_modal_focusable[1].focus();
              }
            } else {
              if (current_modal_focusable[3]) current_modal_focusable[3].focus();
              else current_modal_focusable[0].focus();
            }
          }
        }
        !tabbedInsideModal && (tabbedOutsideDiv = true);
      };

      _addEvent(document, 'keydown', _focusTrapListener);

      if (document.contains) {
        if (_mainContainerClickListener) {
          main_container.removeEventListener('click', _mainContainerClickListener, true);
        }
        
        _mainContainerClickListener = function (e) {
          e = e || window.event;
          if (settings_modal_visible) {
            if (!settings_inner.contains(e.target)) {
              _cookieconsent.hideSettings(0);
              clicked_inside_modal = false;
            } else {
              clicked_inside_modal = true;
            }
          } else if (consent_modal_visible) {
            if (consent_modal.contains(e.target)) {
              clicked_inside_modal = true;
            }
          }
        };

        _addEvent(main_container, 'click', _mainContainerClickListener, true);
      }
    };

    var _guiManager = function (gui_options, only_consent_modal) {
      if (typeof gui_options !== 'object') return;

      var consent_modal_options = gui_options['consent_modal'];
      var settings_modal_options = gui_options['settings_modal'];

      function _setLayout(modal, allowed_layouts, allowed_positions, allowed_transitions, layout, position, transition) {
        position = (position && position.split(" ")) || [];
        if (_inArray(allowed_layouts, layout) > -1) {
          _addClass(modal, layout);
          if (!(layout === 'bar' && position[0] === 'middle') && _inArray(allowed_positions, position[0]) > -1) {
            for (var i = 0; i < position.length; i++) {
              _addClass(modal, position[i]);
            }
          }
        }
        (_inArray(allowed_transitions, transition) > -1) && _addClass(modal, transition);
      }

      if (consent_modal_exists && consent_modal_options) {
        _setLayout(consent_modal, ['box', 'bar', 'cloud'], ['top', 'middle', 'bottom'], ['zoom', 'slide'], consent_modal_options['layout'], consent_modal_options['position'], consent_modal_options['transition']);
      }

      if (!only_consent_modal && settings_modal_options) {
        _setLayout(settings_container, ['bar'], ['left', 'right'], ['zoom', 'slide'], settings_modal_options['layout'], settings_modal_options['position'], settings_modal_options['transition']);
      }
    };

    _cookieconsent.allowedCategory = function (cookie_category) {
      if (!invalid_consent || _config.mode === 'opt-in') {
        var allowed_categories = JSON.parse(_getCookie(_config.cookie_name, 'one', true) || '{}')['categories'] || [];
      } else {
        var allowed_categories = default_enabled_categories;
      }
      return _inArray(allowed_categories, cookie_category) > -1;
    };

    _cookieconsent.run = function (user_config) {
      if (!document.getElementById('cc_div')) {
        _setConfig(user_config);
        if (is_bot) return;

        saved_cookie_content = JSON.parse(_getCookie(_config.cookie_name, 'one', true) || "{}");
        consent_uuid = saved_cookie_content['consent_uuid'];
        var cookie_consent_accepted = consent_uuid !== undefined;

        consent_date = saved_cookie_content['consent_date'];
        consent_date && (consent_date = new Date(consent_date));

        last_consent_update = saved_cookie_content['last_consent_update'];
        last_consent_update && (last_consent_update = new Date(last_consent_update));

        cookie_data = saved_cookie_content['data'] !== undefined ? saved_cookie_content['data'] : null;

        if (revision_enabled && saved_cookie_content['revision'] !== _config.revision) {
          valid_revision = false;
        }

        consent_modal_exists = invalid_consent = (!cookie_consent_accepted || !valid_revision || !consent_date || !last_consent_update || !consent_uuid);

        _createCookieConsentHTML();
        _getModalFocusableData();
        _guiManager(user_config['gui_options']);
        _addDataButtonListeners();

        if (_config.autorun && consent_modal_exists) {
          _cookieconsent.show(user_config['delay'] || 0);
        }

        setTimeout(function () { _addClass(main_container, 'c--anim'); }, 30);
        setTimeout(function () { _handleFocusTrap(); }, 100);

        if (!invalid_consent) {
          var rfc_prop_exists = typeof saved_cookie_content['rfc_cookie'] === "boolean";
          if (!rfc_prop_exists || (rfc_prop_exists && saved_cookie_content['rfc_cookie'] !== _config.use_rfc_cookie)) {
            saved_cookie_content['rfc_cookie'] = _config.use_rfc_cookie;
            _setCookie(_config.cookie_name, JSON.stringify(saved_cookie_content));
          }

          accept_type = _getAcceptType(_getCurrentCategoriesState());
          _manageExistingScripts();

          if (typeof onAccept === 'function') onAccept(saved_cookie_content);
        } else {
          if (_config.mode === 'opt-out') {
            _manageExistingScripts(default_enabled_categories);
          }
        }
      } else {
        _log("CookieConsent [NOTICE]: cookie consent already attached to body!");
      }
    };

    /**
     * EXTENSION: Added clean up method to prevent SPA memory leaks when unmounted.
     */
    _cookieconsent.destroy = function () {
      if (_focusTrapListener) {
        document.removeEventListener('keydown', _focusTrapListener);
        _focusTrapListener = null;
      }
      if (_mainContainerClickListener && main_container) {
        main_container.removeEventListener('click', _mainContainerClickListener, true);
        _mainContainerClickListener = null;
      }
      
      // Clean up settings escape key listener if defined
      var _vln = document.getElementById("c-vln");
      if (_keydownEscapeListener && _vln) {
        _vln.removeEventListener('keydown', _keydownEscapeListener, true);
        _keydownEscapeListener = null;
      }

      if (main_container && main_container.parentNode) {
        main_container.parentNode.removeChild(main_container);
      }
      
      main_container = null;
      consent_modal_exists = false;
      settings_modal_visible = false;
      consent_modal_visible = false;
      
      consent_modal = null;
      settings_container = null;
    };

    _cookieconsent.showSettings = function (delay) {
      setTimeout(function () {
        _addClass(html_dom, "show--settings");
        settings_container.setAttribute('aria-hidden', 'false');
        settings_modal_visible = true;

        setTimeout(function () {
          if (!consent_modal_visible) last_elem_before_modal = document.activeElement;
          else last_consent_modal_btn_focus = document.activeElement;

          if (settings_modal_focusable.length === 0) return;

          if (settings_modal_focusable[3]) settings_modal_focusable[3].focus();
          else settings_modal_focusable[0].focus();

          current_modal_focusable = settings_modal_focusable;
        }, 200);
      }, delay > 0 ? delay : 0);
    };

    var _manageExistingScripts = function (must_enable_categories) {
      if (!_config.page_scripts) return;

      var scripts = document.querySelectorAll('script[' + _config.script_selector + ']');
      var accepted_categories = must_enable_categories || saved_cookie_content['categories'] || [];

      var _loadScripts = function (scripts, index) {
        if (index < scripts.length) {
          var curr_script = scripts[index];
          var curr_script_category = curr_script.getAttribute(_config.script_selector);

          if (_inArray(accepted_categories, curr_script_category) > -1) {
            curr_script.type = 'text/javascript';
            curr_script.removeAttribute(_config.script_selector);

            var src = curr_script.getAttribute('data-src');
            src && curr_script.removeAttribute('data-src');

            var fresh_script = _createNode('script');
            fresh_script.textContent = curr_script.innerHTML;

            (function (destination, source) {
              var attributes = source.attributes;
              var len = attributes.length;
              for (var i = 0; i < len; i++) {
                var attr_name = attributes[i].nodeName;
                destination.setAttribute(attr_name, source[attr_name] || source.getAttribute(attr_name));
              }
            })(fresh_script, curr_script);

            src ? (fresh_script.src = src) : (src = curr_script.src);

            if (src) {
              if (fresh_script.readyState) {
                fresh_script.onreadystatechange = function () {
                  if (fresh_script.readyState === "loaded" || fresh_script.readyState === "complete") {
                    fresh_script.onreadystatechange = null;
                    _loadScripts(scripts, ++index);
                  }
                };
              } else {
                fresh_script.onload = function () {
                  fresh_script.onload = null;
                  _loadScripts(scripts, ++index);
                };
              }
            }

            curr_script.parentNode.replaceChild(fresh_script, curr_script);
            if (src) return;
          }
          _loadScripts(scripts, ++index);
        }
      };

      _loadScripts(scripts, 0);
    };

    var _setCookieData = function (new_data, mode) {
      var set = false;
      if (mode === 'update') {
        cookie_data = _cookieconsent.get('data');
        var same_type = typeof cookie_data === typeof new_data;

        if (same_type && typeof cookie_data === "object") {
          !cookie_data && (cookie_data = {});
          for (var prop in new_data) {
            if (cookie_data[prop] !== new_data[prop]) {
              cookie_data[prop] = new_data[prop];
              set = true;
            }
          }
        } else if ((same_type || !cookie_data) && cookie_data !== new_data) {
          cookie_data = new_data;
          set = true;
        }
      } else {
        cookie_data = new_data;
        set = true;
      }

      if (set) {
        saved_cookie_content['data'] = cookie_data;
        _setCookie(_config.cookie_name, JSON.stringify(saved_cookie_content));
      }
      return set;
    };

    _cookieconsent.set = function (field, data) {
      switch (field) {
        case 'data': return _setCookieData(data['value'], data['mode']);
        default: return false;
      }
    };

    _cookieconsent.get = function (field, cookie_name) {
      var cookie = JSON.parse(_getCookie(cookie_name || _config.cookie_name, 'one', true) || "{}");
      return cookie[field];
    };

    _cookieconsent.getConfig = function (field) {
      return _config[field] || user_config[field];
    };

    var _getCurrentCategoriesState = function () {
      accepted_categories = saved_cookie_content['categories'] || [];
      rejected_categories = all_categories.filter(function (category) {
        return (_inArray(accepted_categories, category) === -1);
      });
      return { accepted: accepted_categories, rejected: rejected_categories };
    };

    var _getAcceptType = function (currentCategoriesState) {
      var type = 'custom';
      var necessary_categories_length = readonly_categories.filter(function (readonly) {
        return readonly === true;
      }).length;

      if (currentCategoriesState.accepted.length === all_categories.length) type = 'all';
      else if (currentCategoriesState.accepted.length === necessary_categories_length) type = 'necessary';
      return type;
    };

    _cookieconsent.getUserPreferences = function () {
      var currentCategoriesState = _getCurrentCategoriesState();
      var accept_type = _getAcceptType(currentCategoriesState);
      return {
        'accept_type': accept_type,
        'accepted_categories': currentCategoriesState.accepted,
        'rejected_categories': currentCategoriesState.rejected
      };
    };

    _cookieconsent.loadScript = function (src, callback, attrs) {
      var function_defined = typeof callback === 'function';

      if (!document.querySelector('script[src="' + src + '"]')) {
        var script = _createNode('script');
        if (attrs && attrs.length > 0) {
          for (var i = 0; i < attrs.length; ++i) {
            attrs[i] && script.setAttribute(attrs[i]['name'], attrs[i]['value']);
          }
        }
        if (function_defined) script.onload = callback;
        script.src = src;
        document.head.appendChild(script);
      } else {
        function_defined && callback();
      }
    };

    _cookieconsent.updateScripts = function () {
      _manageExistingScripts();
    };

    _cookieconsent.show = function (delay, create_modal) {
      if (create_modal === true) _createConsentModal(_config.current_lang);
      if (consent_modal_exists) {
        setTimeout(function () {
          _addClass(html_dom, "show--consent");
          consent_modal.setAttribute('aria-hidden', 'false');
          consent_modal_visible = true;

          setTimeout(function () {
            last_elem_before_modal = document.activeElement;
            current_modal_focusable = consent_modal_focusable;
          }, 200);
        }, delay > 0 ? delay : (create_modal ? 30 : 0));
      }
    };

    _cookieconsent.hide = function () {
      if (consent_modal_exists) {
        _removeClass(html_dom, "show--consent");
        consent_modal.setAttribute('aria-hidden', 'true');
        consent_modal_visible = false;

        setTimeout(function () {
          last_elem_before_modal.focus();
          current_modal_focusable = null;
        }, 200);
      }
    };

    _cookieconsent.hideSettings = function () {
      _removeClass(html_dom, "show--settings");
      settings_modal_visible = false;
      settings_container.setAttribute('aria-hidden', 'true');

      setTimeout(function () {
        if (consent_modal_visible) {
          last_consent_modal_btn_focus && last_consent_modal_btn_focus.focus();
          current_modal_focusable = consent_modal_focusable;
        } else {
          last_elem_before_modal && last_elem_before_modal.focus();
          current_modal_focusable = null;
        }
        clicked_inside_modal = false;
      }, 200);
    };

    _cookieconsent.accept = function (_categories, _exclusions) {
      var categories = _categories || undefined;
      var exclusions = _exclusions || [];
      var to_accept = [];

      var _getCurrentPreferences = function () {
        var toggles = document.querySelectorAll('.c-tgl') || [];
        var states = [];
        for (var i = 0; i < toggles.length; i++) {
          if (toggles[i].checked) states.push(toggles[i].value);
        }
        return states;
      };

      if (!categories) {
        to_accept = _getCurrentPreferences();
      } else {
        if (typeof categories === "object" && typeof categories.length === "number") {
          for (var i = 0; i < categories.length; i++) {
            if (_inArray(all_categories, categories[i]) !== -1) to_accept.push(categories[i]);
          }
        } else if (typeof categories === "string") {
          if (categories === 'all') to_accept = all_categories.slice();
          else {
            if (_inArray(all_categories, categories) !== -1) to_accept.push(categories);
          }
        }
      }

      if (exclusions.length >= 1) {
        for (i = 0; i < exclusions.length; i++) {
          to_accept = to_accept.filter(function (item) { return item !== exclusions[i] });
        }
      }

      for (i = 0; i < all_categories.length; i++) {
        if (readonly_categories[i] === true && _inArray(to_accept, all_categories[i]) === -1) {
          to_accept.push(all_categories[i]);
        }
      }

      _saveCookiePreferences(to_accept);
    };

    _cookieconsent.eraseCookies = function (_cookies, _path, _domain) {
      var cookies = [];
      var domains = _domain ? [_domain, "." + _domain] : [_config.cookie_domain, "." + _config.cookie_domain];

      if (typeof _cookies === "object" && _cookies.length > 0) {
        for (var i = 0; i < _cookies.length; i++) {
          this.validCookie(_cookies[i]) && cookies.push(_cookies[i]);
        }
      } else {
        this.validCookie(_cookies) && cookies.push(_cookies);
      }

      _eraseCookies(cookies, _path, domains);
    };

    var _setCookie = function (name, value) {
      var cookie_expiration = _config.cookie_expiration;

      if (typeof _config.cookie_necessary_only_expiration === 'number' && accept_type === 'necessary')
        cookie_expiration = _config.cookie_necessary_only_expiration;

      value = _config.use_rfc_cookie ? encodeURIComponent(value) : value;

      var date = new Date();
      date.setTime(date.getTime() + (1000 * (cookie_expiration * 24 * 60 * 60)));
      var expires = "; expires=" + date.toUTCString();

      var cookieStr = name + "=" + (value || "") + expires + "; Path=" + _config.cookie_path + ";";
      cookieStr += " SameSite=" + _config.cookie_same_site + ";";

      if (window.location.hostname.indexOf(".") > -1) {
        cookieStr += " Domain=" + _config.cookie_domain + ";";
      }

      if (window.location.protocol === "https:") {
        cookieStr += " Secure;";
      }

      document.cookie = cookieStr;
    };

    var _getCookie = function (name, filter, get_value) {
      var found;
      if (filter === 'one') {
        found = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
        found = found ? (get_value ? found.pop() : name) : "";

        if (found && name === _config.cookie_name) {
          try { found = JSON.parse(found); } 
          catch (e) {
            try { found = JSON.parse(decodeURIComponent(found)); } 
            catch (e) { found = {}; }
          }
          found = JSON.stringify(found);
        }
      } else if (filter === 'all') {
        var cookies = document.cookie.split(/;\s*/); found = [];
        for (var i = 0; i < cookies.length; i++) {
          found.push(cookies[i].split("=")[0]);
        }
      }
      return found;
    };

    var _eraseCookies = function (cookies, custom_path, domains) {
      var path = custom_path ? custom_path : '/';
      var expires = 'Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

      for (var i = 0; i < cookies.length; i++) {
        for (var j = 0; j < domains.length; j++) {
          document.cookie = cookies[i] + '=; path=' + path +
            (domains[j].indexOf('.') === 0 ? '; domain=' + domains[j] : "") + '; ' + expires;
        }
      }
    };

    _cookieconsent.validCookie = function (cookie_name) {
      return _getCookie(cookie_name, 'one', true) !== "";
    };

    var _addEvent = function (elem, event, fn, isPassive) {
      elem.addEventListener(event, fn, isPassive === true ? { passive: true } : false);
    };

    var _getKeys = function (obj) {
      if (typeof obj === "object") {
        return Object.keys(obj);
      }
    };

    var _addClass = function (elem, classname) {
      elem.classList.add(classname);
    };

    var _removeClass = function (el, className) {
      el.classList.remove(className);
    };

    var _hasClass = function (el, className) {
      return el.classList.contains(className);
    };

    return _cookieconsent;
  };

  var init = 'initCookieConsent';
  if (typeof window !== 'undefined' && typeof window[init] !== 'function') {
    window[init] = CookieConsent;
  }
})();